import { ref, watch } from 'vue';
export default function useURLParameters(frame, selectedTrackId, mediaLoaded, selectTrack, seek, uiSelection) {
    const enableParams = ref(false);
    const setEnableURLParams = (val) => {
        enableParams.value = val;
    };
    const queryConfigurationId = ref('');
    watch([selectedTrackId, frame], () => {
        // update query parameters based on this value
        if (!enableParams.value) {
            return;
        }
        const values = [];
        if (selectedTrackId.value !== null && uiSelection) {
            values.push(`selectedTrackId=${selectedTrackId.value}`);
        }
        if (frame.value !== 0) {
            values.push(`frame=${frame.value}`);
        }
        if (queryConfigurationId.value) {
            values.push(`configurationId=${queryConfigurationId.value}`);
        }
        const currentLocation = window.location.href;
        if (values.length === 0) {
            window.history.replaceState(null, '', currentLocation.replace(/\?.*/, '')); // Override history
            return;
        }
        const urlParameters = `?${values.join('&')}`;
        if (currentLocation.includes('?')) {
            window.history.replaceState(null, '', currentLocation.replace(/\?.*/, urlParameters)); // Override history
        }
        else {
            window.history.replaceState(null, '', `${currentLocation}${urlParameters}`); // Override history
        }
    });
    const loadURLParams = () => {
        const currentLocation = window.location.href;
        if (currentLocation.includes('?')) {
            // Lets get everything after the ?
            const urlParams = currentLocation.slice(currentLocation.indexOf('?') + 1);
            const urlSplitParams = urlParams.split('&');
            const paramMapping = {};
            urlSplitParams.forEach((item) => {
                const splits = item.split('=');
                if (splits.length > 1) {
                    [, paramMapping[splits[0]]] = splits;
                }
            });
            if (paramMapping.selectedTrackId !== undefined) {
                const trackId = parseInt(paramMapping.selectedTrackId, 10);
                if (!Number.isNaN(trackId)) {
                    selectTrack(trackId, false);
                }
            }
            if (paramMapping.frame !== undefined) {
                const urlFrame = parseInt(paramMapping.frame, 10);
                if (!Number.isNaN(urlFrame)) {
                    seek(urlFrame);
                }
            }
            if (paramMapping.configurationId !== undefined) {
                queryConfigurationId.value = paramMapping.configurationId;
            }
        }
    };
    watch(mediaLoaded, () => {
        loadURLParams();
        enableParams.value = true;
    });
    return {
        setEnableURLParams,
        loadURLParams,
    };
}
